import { useTranslation } from 'react-i18next';
import { Flex, Text } from '@kognitos/lattice';

import type { IMetadataItem } from '../../types';
import { MetadataSidebarItem } from './MetadataSidebarItem';

interface IMetadataSidebarProps {
  items: IMetadataItem[];
  selectedIndex: number;
  onSelect: (index: number) => void;
}

/**
 * MetadataSidebar component for preview layover
 * Displays a scrollable list of metadata items with type information
 */
export function MetadataSidebar({
  items,
  selectedIndex,
  onSelect,
}: IMetadataSidebarProps) {
  const { t } = useTranslation('outputs');
  const allFiles = items.every(item => item.type === 'file');

  return (
    <Flex direction="column" align="stretch" flex="1" className="min-h-0">
      <Flex
        direction="column"
        align="stretch"
        gap={1}
        flex="1"
        overflow="auto"
        className="min-h-0"
      >
        {items.map((item, index) => {
          const itemKey = `${item.label}-${item.type}-${index}`;
          return (
            <MetadataSidebarItem
              key={itemKey}
              item={item}
              index={index}
              isSelected={selectedIndex === index}
              onSelect={onSelect}
            />
          );
        })}
      </Flex>
      {/* Outside the scroll container so rows can never run underneath it. */}
      <Flex className="shrink-0 pt-3">
        <Text level="small" color="muted" weight="medium">
          {allFiles
            ? t('outputs.card.files', { count: items.length })
            : t('outputs.modal.items', { count: items.length })}
        </Text>
      </Flex>
    </Flex>
  );
}
